import { z } from 'zod'
import noLeadingSpaces from '../../../src/utilities/noLeadingSpaces'

const passerror =
  'Password should contain at least one uppercase letter, one lowercase letter, one digit, and one special character, with a minimum length of eight characters, and must not contain any spaces.'

export const registrationSchema = z.object({
  name: z.string().min(1, 'Name is required').max(50),

  email: z
    .string()
    .min(5, { message: 'Required' })
    .superRefine((value, ctx) => {
      if (value !== '') {
        if (!/^[\w-.+]+@([\w-]+\.)+[\w-]{2,4}$/.test(value)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'Invalid email format.',
          })
        }
      }
    })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed',
    }),

  background: z.string(),

  mobile: z
    .string()
    .nullable()
    .transform((value) => (value === null ? '' : value))
    .refine(
      (value) => {
        return (
          (/^\d{10}$/.test(value) &&
            parseInt(value, 10) !== 0 &&
            !/\+/.test(value)) ||
          value === ''
        )
      },
      {
        message: 'Enter a Valid 10-digit Mobile Number',
      }
    ),
  // whatsapp_no: z
  //   .string()
  //   .nullable()
  //   .transform((value) => (value === null ? '' : value))
  //   .refine(
  //     (value) => {
  //       return (
  //         (/^\d{10}$/.test(value) &&
  //           parseInt(value, 10) !== 0 &&
  //           !/\+/.test(value)) ||
  //         value === ''
  //       )
  //     },
  //     {
  //       message: 'Enter a Valid 10-digit Mobile Number',
  //     }
  //   ),

  role_name: z
    .string({ invalid_type_error: 'Required.' })
    .min(1, { message: 'Required.' }),
  role: z.any(),

  district: z.string().min(1, 'District is required'),
  district_id: z.any().optional(),

  password: z
    .string()
    .refine((val) => !val || /^[^\s]*$/.test(val), {
      message: 'Space not allowed',
    })
    .refine((val) => !val || /.*[A-Z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*[a-z].*/.test(val), { message: passerror })
    .refine((val) => !val || /.*\d.*/.test(val), { message: passerror })
    .refine(
      (val) => !val || /.*[`~<>?,./!@#$%^&*()\-_=+"'\|{}\[\];:\\].*/.test(val),
      { message: passerror }
    )
    .refine((val) => !val || val.length >= 8, { message: passerror }),

  password_confirmation: z
    .string()
    .min(6, { message: 'Confirm Password must be at least 6 characters.' })
    .refine(noLeadingSpaces, {
      message: 'Leading spaces are not allowed.',
    }),
  whatsapp_no: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? '')
    .refine(
      (value) =>
        value === '' ||
        (/^\d{10}$/.test(value) &&
          parseInt(value, 10) !== 0 &&
          !/\+/.test(value)),
      { message: 'Enter a Valid 10-digit Mobile Number' }
    ),

  whatsapp_choice: z
    .string()
    .nonempty('Please select whether this is your WhatsApp number'),
})

export type RegistrationSchema = z.infer<typeof registrationSchema>
